/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const LineIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.9375 11.25H5.803H6.5625H8.4375H11.697H13.4375H14.0625H19.0625C19.3111 11.25 19.5496 11.1183 19.7254 10.8839C19.9012 10.6495 20 10.3315 20 10C20 9.66848 19.9012 9.35054 19.7254 9.11612C19.5496 8.8817 19.3111 8.75 19.0625 8.75H14.0625H13.4375H11.697H8.4375H6.5625H5.803H0.9375C0.68886 8.75 0.450403 8.8817 0.274587 9.11612C0.0987721 9.35054 0 9.66848 0 10C0 10.3315 0.0987721 10.6495 0.274587 10.8839C0.450403 11.1183 0.68886 11.25 0.9375 11.25Z"
        fill="black"
      />
    </svg>
  )
}
